import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import Aboutus from './views/Aboutus.vue'
import Contactus from './views/Contactus.vue'
import Team from './views/Team.vue'
import FranchiseDetail from './components/FranchiseDetail.vue'
import Franchise from './views/Franchise.vue'
import Blog from './views/Blog.vue'
import BlogDetail from './components/BlogDetail.vue'
import AllEvents from './views/AllEvents.vue'
import AllWebinars from './views/AllWebinars.vue'
import ListYourFranchise from './components/ListYourFranchise.vue'
import InvestorRegistration from './views/InvestorRegistration.vue'
import TeamMemberProfile from './components/TeamMemberProfile.vue'
import EventDetail from './views/EventDetail.vue'
// import CategoryView from './views/CategoryView.vue' // Uncomment and create if needed

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'Aboutus', component: Aboutus },
  { path: '/team', name: 'Team', component: Team },
  { path: '/team/:id', name: 'TeamMemberProfile', component: TeamMemberProfile },
  { path: '/franchises', name: 'FranchisesSection', component: Franchise },
  { path: '/category/:slug', name: 'Category', component: Franchise },
  { path: '/franchise/:id', name: 'FranchiseDetail', component: FranchiseDetail },
  { path: '/contactus', name: 'Contactus', component: Contactus },
  { path: '/blogs', name: 'AllBlogs', component: Blog },
  { path: '/blog/:slug', name: 'BlogDetail', component: BlogDetail },
  { path: '/events', name: 'AllEvents', component: AllEvents },
  { path: '/event/:id', name: 'EventDetail', component: EventDetail },
  { path: '/all-webinars', name: 'AllWebinars', component: AllWebinars },
  { path: '/list-franchise', name: 'ListYourFranchise', component: ListYourFranchise },
  { path: '/investor-registration', name: 'InvestorRegistration', component: InvestorRegistration },
  // { path: '/event/:id', name: 'EventDetail', component: EventDetail },
  // { path: '/category/:slug', name: 'Category', component: CategoryView },
  // Catch-all route for unmatched paths
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top on navigation
    return { top: 0 }
  }
})
export default router 